import React, { useState } from 'react';
import './Header.scss';
import { useNavigate } from 'react-router-dom';


function Header() {
    const [isMenuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!isMenuOpen);
    };
    let navigate = useNavigate();

    const goToHome = () => {navigate('/');};
    const goToContact = () => {navigate('/contact');};
    const goToTemplate = () => {navigate('/template');};
    const goToPricing = () => {navigate('/pricing');};
    const goToAbout = () => {navigate('/about');};
    const navigateToExternalUrl = () => {window.location.href = "https://api.walletly.ai/signup";};
    const navigateToExternalUrl1 = () => {window.location.href = "https://api.walletly.ai";};

    return (
        <div className='header d-flex align-items-center justify-content-between padding'>
            {console.log(isMenuOpen)}
            <div className='cp' onClick={goToHome}>
                {/* <img loading="lazy" width={139} src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/d2c1fd33-babc-4b43-d890-217e019e7600/Digi' alt="Logo"/> */}
                <img loading="lazy" width={150} src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/d2c1fd33-babc-4b43-d890-217e019e7600/Digi' alt="Logo"/>
            </div>
            <button className="menu-toggle" onClick={toggleMenu}>
                {isMenuOpen ? '✖' : '☰'}
            </button>
            <div className={`menu-items align-items-center ${isMenuOpen ? 'show' : 'hide'}`}>
                <div className='text1 cp' onClick={goToPricing}>Pricing</div>
                <div className='text1 cp' onClick={goToAbout}>About Us</div>
                <div className='text1 cp' onClick={goToTemplate}>Templates</div>
                <div className='text1 cp' onClick={goToContact}>Contact Us</div>
                <div className='text1 hide'>|</div>
                <div className='text1 hide cp' onClick={navigateToExternalUrl1}>Log in</div>
                <div className='button1p'><div className='button1 mob-mb-15 ms-3 cp' onClick={navigateToExternalUrl}>Get Started</div></div>
                <div className='button1p'><div className='text1b hide1 cp' onClick={navigateToExternalUrl1}>Log in</div></div>
            </div>
        </div>
    );
}

export default Header;
